var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVortexHealthcare01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 438 416",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#09B2C9;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M336,138.49H309a79.25,79.25,0,0,0-157.53,0H124.54a26.46,26.46,0,0,0-26.43,26.43v141a26.46,26.46,0,0,0,26.43,26.43H336a26.46,26.46,0,0,0,26.43-26.43v-141A26.46,26.46,0,0,0,336,138.49ZM230.25,85.63a61.76,61.76,0,0,1,61,52.86H169.21A61.77,61.77,0,0,1,230.25,85.63ZM283.11,253a8.8,8.8,0,0,1-8.81,8.81H256.68v17.62a8.8,8.8,0,0,1-8.81,8.81H212.63a8.8,8.8,0,0,1-8.81-8.81V261.82H186.21A8.8,8.8,0,0,1,177.4,253V217.78a8.8,8.8,0,0,1,8.81-8.81h17.61V191.35a8.8,8.8,0,0,1,8.81-8.81h35.24a8.8,8.8,0,0,1,8.81,8.81V209H274.3a8.8,8.8,0,0,1,8.81,8.81Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVortexHealthcare01);
export default __webpack_public_path__ + "static/media/Vortex_Healthcare-01.039f08eb6af76a82e3906711a0f30046.svg";
export { ForwardRef as ReactComponent };